import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Icon, Form, Spin, Select, Input, Menu, Dropdown, Button, Col, DatePicker,
} from 'antd';
import moment from 'moment';
import {
    customer_details_titles, customer_details_keys, time_picker_options, preferred_contact_method,
} from '../statics';
import { lead_handler, edit_field } from '../../redux/actions/lead_handler.actions';
import {
    changeLeadCustomerRequest,
    updateLeadCustomerDateRequest,
} from '../../redux/actions/change_lead_customer.actions';
import { validation_rules } from '../../../../../shared/validation_rules';
import { searchLeadCountyRequest } from '../../redux/actions/search_lead_county.actions';
import { addressLookupRequest, addDataByStreetRequest } from '../../redux/actions/address_lookup.actions';

const mapStateToProps = (state) => {
    const {
        customer_details, isEditField, index, loading, streets, data_by_streets, counties,
    } = state.Leads.Lead_profile.Ref_lead_customer;
    const { root_id, current_status } = state.Leads.Lead_profile.Lead_general;
    return {
        loading, customer_details, counties, isEditField, index, streets, data_by_streets, root_id, current_status,
    };
};
const Options = Select.Option;
const { Option } = Select;
const
    MenuItem = Menu.Item;

const DISABLE_STATUSES = ['Collection Arranged', 'Bought', 'Not Bought - Poor Condition', 'Not Bought - Price', 'Arrange Collection', 'Transport Arranged', 'Transport Arranged (Trade)', 'Bought (Dans)', 'Delivery Arranged (Trade)', 'Arrange Collection (Trade)'];


export default connect(mapStateToProps, {
    edit_field,
    lead_handler,
    changeLeadCustomerRequest,
    searchLeadCountyRequest,
    addressLookupRequest,
    addDataByStreetRequest,
    updateLeadCustomerDateRequest,
})(class CustomerDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isDirtyCounty: false,
        };
    }

    edit = (index) => this.props.edit_field(true, index);

    handleChange = (key, value, obj) => {
        if (key === 'phone') {
            if (/^\d+$/.test(value) || value === '') {
                this.props.lead_handler(key, value, obj);
            } else return null;
        } else {
            this.props.lead_handler(key, value, obj);
        }
    };


    save = (_id, key, value) => {
        if (key === 'customer_collection_date') {
            // Date picker value has format D MMM YYYY, which is saved in DB with 1 hour difference:
            // 10 June 2025 is saved as 2025-06-10T23:00:00.000+00:00
            // We need only correct day, that's why as a hotfix 3 hours are added to the date.
            this.props.updateLeadCustomerDateRequest(this.props.root_id, moment(value).add(3, 'hours'));
        } else if (key === 'post_code') {
            const post_code_update = {
                'address.street': this.props.data_by_streets?.line1,
                'address.county': this.state.isDirtyCounty ? this.props.counties?._id || 'undefined' : this.props.customer_details.address?.county?._id,
                'address.city': this.props.data_by_streets?.post_town,
                'address.country': this.props.data_by_streets?.country_name,
                'address.post_code': this.props.data_by_streets?.post_code,
            };
            this.props.changeLeadCustomerRequest(_id, key, post_code_update);
        } else {
            this.props.changeLeadCustomerRequest(_id, key, key === 'county'
                ? this.props.customer_details.address.county._id
                : value);
        }
    };

    searchCustomerCounties = (value) => !/92|91/i.test(value.charCodeAt(0)) && this.props.searchLeadCountyRequest(value);

    getStreetsByPostCode = () => this.props.addressLookupRequest('postcode', this.props.customer_details.address.post_code, 'searchByTerm');

    chooseOption = (data) => {
        this.setState({ isDirtyCounty: true });
        return this.props.addDataByStreetRequest(data.key);
    };

    render() {
        let customerDate;
        let data;
        let county_name;
        let shouldHidePreferredContactTime;
        const {
            counties, isEditField, customer_details, cdKey, streets, data_by_streets, current_status,
        } = this.props;
        if (customer_details) {
            const {
                address: {
                    city, country = 'United Kingdom', post_code, street,
                }, email, full_name, phone, customer_collection_date,
            } = customer_details;

            const date = customer_collection_date && moment(customer_collection_date);
            customerDate = date && date.isValid() && date.format('D MMM YYYY');

            if (this.state.isDirtyCounty) {
                county_name = data_by_streets && data_by_streets.county ? data_by_streets.county : '';
            } else {
                county_name = customer_details.address.county
                    ? customer_details.address.county.name
                    : null;
            }

            data = [
                full_name,
                phone,
                email,
                country,
                city,
                county_name,
                street,
                post_code && post_code.toUpperCase()
                    .trim(),
                customer_details.preferred_contact_method && customer_details.preferred_contact_method,
                customer_details.preferred_contact_time && customer_details.preferred_contact_time,
                customerDate,
            ];

            // hide preferred contact time if preferred contact method selected email or SMS!
            shouldHidePreferredContactTime = customer_details.preferred_contact_method
                && (customer_details.preferred_contact_method === 'Email'
                    || customer_details.preferred_contact_method === 'SMS');
        }

        const menu = (
            <Menu>
                {streets && streets.map((street) => (
                    <MenuItem
                        key={street.id}
                        onClick={this.chooseOption}
                    >
                        {`${street.street_address}, ${street.place}`}
                    </MenuItem>
                ))}
            </Menu>
        );

        return (
            <Spin spinning={this.props.loading} tip="Customer details updating ...">
                <Col span={24}>
                    {customer_details
                        && (
                            <Fragment>
                                <h3 className="header">Customer Details</h3>
                                {
                                    data.map((item, index) => (
                                        <p key={index} className="price_details">
                                            <span>
                                                {customer_details_titles[index]}
                                                :
                                            </span>
                                            {
                                                isEditField && this.props.index === index
                                                    ? (
                                                        <Fragment>
                                                            {
                                                                customer_details_titles[index] === 'County'
                                                                    ? (
                                                                        <Select
                                                                            showSearch
                                                                            showArrow={false}
                                                                            filterOption={false}
                                                                            placeholder="Select County"
                                                                            notFoundContent="Not Found"
                                                                            size="small"
                                                                            defaultValue={county_name}
                                                                            style={{
                                                                                width: '50%',
                                                                                fontWeight: '400',
                                                                                fontSize: '12px',
                                                                            }}
                                                                            onChange={(key, value) => this.handleChange(key, value, 'county')}
                                                                            onSearch={this.searchCustomerCounties}
                                                                        >
                                                                            {
                                                                                counties?.length
                                                                                    ? counties.map((brand) => (
                                                                                        <Options
                                                                                            value={brand._id}
                                                                                            key={brand._id}
                                                                                        >
                                                                                            {brand.name}
                                                                                        </Options>
                                                                                    ))
                                                                                    : []
                                                                            }
                                                                        </Select>
                                                                    )
                                                                    : (customer_details_titles[index] === 'Preferred contact time')
                                                                        ? (
                                                                            <Select
                                                                                style={{ width: 160 }}
                                                                                size="small"
                                                                                value={customer_details.preferred_contact_time}
                                                                                onChange={(value) => this.handleChange(customer_details_keys[index], value)}
                                                                            >
                                                                                {
                                                                                    time_picker_options.map((option, index) => (
                                                                                        <Option
                                                                                            value={option}
                                                                                            key={index}
                                                                                        >
                                                                                            {option}
                                                                                        </Option>
                                                                                    ))
                                                                                }
                                                                            </Select>
                                                                        )
                                                                        : (customer_details_titles[index] === 'Preferred contact method')
                                                                            ? (
                                                                                <Select
                                                                                    style={{ width: 160 }}
                                                                                    size="small"
                                                                                    onChange={(value) => this.save(this.props.customer_details._id, customer_details_keys[index], value)}
                                                                                    value={customer_details.preferred_contact_method}
                                                                                >
                                                                                    {
                                                                                        preferred_contact_method.map((option, index) => (
                                                                                            <Option
                                                                                                value={option}
                                                                                                key={index}
                                                                                            >
                                                                                                {option}
                                                                                            </Option>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            )
                                                                            : (customer_details_titles[index] === 'Preferred Collection Date')
                                                                                ? (
                                                                                    <DatePicker
                                                                                        value={customerDate && moment(customerDate)}
                                                                                        style={{ width: '55%' }}
                                                                                        format="D MMM YYYY"
                                                                                        disabled={DISABLE_STATUSES.includes(current_status.name) && customerDate && customerDate !== ''}
                                                                                        disabledDate={(current) => current && current.diff(moment().format('YYYY-MM-DD')) < 0}
                                                                                        onChange={(date, dateString) => this.handleChange(customer_details_keys[index], dateString || null)}
                                                                                    />
                                                                                )
                                                                                : (
                                                                                    <Input
                                                                                        value={item}
                                                                                        size="small"
                                                                                        style={{ width: '40%' }}
                                                                                        onPressEnter={() => {
                                                                                            this.save(this.props.customer_details._id, customer_details_keys[index], item);
                                                                                        }}
                                                                                        onChange={(event) => this.handleChange(customer_details_keys[index], event.target.value)}
                                                                                    />
                                                                                )
                                                            }
                                                            {
                                                                customer_details_titles[index] === 'Post Code'
                                                                && (
                                                                    <Dropdown trigger={['click']} overlay={menu}>
                                                                        <Button
                                                                            size="small"
                                                                            onClick={this.getStreetsByPostCode}
                                                                            className="postcode"
                                                                        >
                                                                            Lookup
                                                                        </Button>
                                                                    </Dropdown>
                                                                )
                                                            }
                                                            <Icon
                                                                type="save"
                                                                spin={customer_details_keys[index] === 'email' && validation_rules.email(item)}
                                                                style={{ marginLeft: '5px' }}
                                                                onClick={() => this.save(this.props.customer_details._id, customer_details_keys[index], item)}
                                                            />
                                                            <div style={{
                                                                fontSize: '12px',
                                                                color: 'green',
                                                                fontStyle: 'italic',
                                                                paddingLeft: '30%',
                                                            }}
                                                            >
                                                                {
                                                                    customer_details_titles[index] === 'Post Code' && data_by_streets
                                                                    && `${data_by_streets.line1} ${data_by_streets.line2}, ${data_by_streets.county}, ${data_by_streets.post_town}, ${data_by_streets.country_name}`
                                                                }
                                                            </div>
                                                            <div
                                                                className="validationLeadCustomerError"
                                                            >
                                                                {customer_details_keys[index] === 'email' && validation_rules.email(item)}
                                                            </div>
                                                        </Fragment>
                                                    )
                                                    : (customer_details_titles[index] === 'Preferred contact time' && shouldHidePreferredContactTime
                                                        ? <span className="value">None</span>
                                                        : (
                                                            <span className="value">
                                                                {item || 'None'}
                                                                {
                                                                    <Icon
                                                                        type="edit"
                                                                        onClick={() => this.edit(index)}
                                                                        style={{ marginLeft: '5px' }}
                                                                    />
                                                                }
                                                                {
                                                                    customer_details_keys[index] === cdKey
                                                                && <Spin size="small" style={{ marginLeft: '40px' }} />
                                                                }
                                                            </span>
                                                        )
                                                    )
                                            }
                                        </p>
                                    ))
                                }
                            </Fragment>
                        )
                    }
                </Col>
            </Spin>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/CustomerDetails.js